module.exports = __webpack_public_path__ + "img/docx.09605f9b.png";